<template>
  <div class="page-template">
<!--    采购业务设置-->
    <div class="page-title">{{ title }}</div>
    <div class="page-edit">
<!--      <form-template ref="formTemplate" @submit="submitData">-->
<!--      </form-template>-->
      <el-form :model="form" ref="form" class="setting-form" label-width="280px" :rules="rules">
        <el-col :span="24">
          <el-form-item prop="supplierGoods" label="是否按主供应商选择商品">
            <el-radio-group
              v-model="form.supplierGoods"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="greaterGoodsPrice" label="进价大于档案进价时提示">
            <el-radio-group
              v-model="form.greaterGoodsPrice"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="updateGoods" label="采购收货单生效时更新商品档案中的进价" >
            <el-radio-group
              v-model="form.updateGoods"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="!storeId">
          <el-form-item prop="purchaseForStore" label="总部为门店进行采购" >
            <el-radio-group
              v-model="form.purchaseForStore"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="form.purchaseForStore == 1 && !storeId">
          <el-form-item prop="storeIdList" label="选择门店" >
            <el-select v-model="form.storeIdList" multiple @change="selectStore" collapse-tags>
              <el-option
                v-for="(item,index) in storeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="purchaseOrderExpireDay" label="采购订单有效天数">
            <el-input type="number" v-model="form.purchaseOrderExpireDay" @change="handleChange"></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div class="foot">
        <el-button type="primary" @click="submitData">提交</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import formTemplate from '@/components/template/formTemplate';
import api from '../../config/api';
// import api from "@/config/api";

export default {
  components: {
    formTemplate
  },
  data() {
    return {
      typeList: [
        {label: '启用', id: 1},
        {label: '不启用', id: 0}
      ],
      isDisabled: false,
      form: {
        updateGoods: 0, // 采购收货单生效时更新商品档案中的进价
        greaterGoodsPrice: 1, // 进价大于档案进价时提示
        supplierGoods: 0, // 进价大于档案进价时提示
        purchaseForStore: 0, // 总部为门店采购
        storeIdList: '', // 门店
        purchaseOrderExpireDay: 30// 采购订单有效天数
      },
      title: '',
      dialogVisibility: false,
      storeOptions: [],
      rules: {
        storeIdList: {required: true, message: '请选择指定门店', trigger: 'change'},
        purchaseOrderExpireDay: {required: true, message: '请填写采购订单有效天数', trigger: 'change'}
      },
      storeStr: '',
      storeId: null
      // addColumns: {
      //   formType: 'insert',
      //   labelWidth: "280px",
      //   span: 24,
      //   columns: [
      //     {label: '基础信息', type: 'title', span: 24},
      //     {
      //       label: "采购收货单生效时更新商品档案中的进价",
      //       type: "radio",
      //       prop: "updateGoods",
      //       defaultValue:20,
      //       data: this.$utils.getCacheStatus("sysPayMode.status"),
      //     },
      //     {
      //       label: "进价大于档案进价时提示",
      //       type: "radio",
      //       prop: "greaterGoodsPrice",
      //       defaultValue:10,
      //       data: this.$utils.getCacheStatus("sysPayMode.status"),
      //     },
      //     {
      //       label: "按照主供应商选择商品",
      //       type: "radio",
      //       prop: "supplierGoods",
      //       defaultValue:20,
      //       data: this.$utils.getCacheStatus("sysPayMode.status"),
      //     }
      //   ],
      // }
    };
  },
  computed: {
    numberList() {
      return this.$utils.getCacheStatus('asGoodsDefault.artNoLength')
    }
  },
  created() {
    this.storeId = JSON.parse(localStorage.getItem('SYSUSER')).storeId // 商户id
  },
  mounted() {
    this.title = document.title;
    this.getSetDetail()
    this.getStoreOptions()
  },
  methods: {
    handleChange(val) {
      if (val > 360) {
        this.form.purchaseOrderExpireDay = 360
      }
    },
    // 门店
    getStoreOptions() {
      this.$axios.fetchPost(api.system.seStore + '/list', {}).then(res => {
        // res.data.unshift({name:'全部门店',id:null})
        this.storeOptions = res.data
      })
    },
    // 选择门店
    selectStore(val) {
      let str = ''
      val.forEach(v => {
        str += v + ','
      })
      this.storeStr = str
    },
    // 获取设置详情
    getSetDetail() {
      this.$axios.fetchGet(api.purchase.pcPurchaseDefaultDetail, {}).then(data => {
        if (data.code === 200) {
          if (data.data) {
            if (data.data.updateGoods) {
              data.data.updateGoods = 1
            } else {
              data.data.updateGoods = 0
            }

            if (data.data.greaterGoodsPrice) {
              data.data.greaterGoodsPrice = 1
            } else {
              data.data.greaterGoodsPrice = 0
            }

            if (data.data.supplierGoods) {
              data.data.supplierGoods = 1
            } else {
              data.data.supplierGoods = 0
            }

            if (data.data.purchaseForStore) {
              data.data.purchaseForStore = 1
            } else {
              data.data.purchaseForStore = 0
            }

            // 门店
            let arr = []
            if (data.data.storeIdList && data.data.storeIdList.indexOf(',') != -1) {
              data.data.storeIdList.split(',').forEach(v => {
                if (v) {
                  arr.push(Number(v))
                }
              })
            }
            data.data.storeIdList = arr
            this.form = data.data;
          }
        } else {
          this.$message({message: data.errorMsg, type: 'error'});
        }
      }).catch((err) => {
        this.$message({message: '请求失败', type: 'error'});
      });
    },
    // 重置
    reset() {
      this.form = {
        updateGoods: 0, // 采购收货单生效时更新商品档案中的进价
        greaterGoodsPrice: 1, // 进价大于档案进价时提示
        supplierGoods: 0, // 进价大于档案进价时提示
        purchaseForStore: 0, // 总部为门店采购
        storeIdList: '', // 门店
        purchaseOrderExpireDay: ''// 采购订单有效天数
      }
      this.getSetDetail()
    },
    // 提交
    submitData() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '提交中，请稍候...',
            background: 'rgba(225, 225, 225, 0.8)'
          });
          if (!this.storeId) {
            this.selectStore(this.form.storeIdList)
          }
          this.form.storeIdList = this.storeStr // 门店
          if (this.form.purchaseForStore == 0) {
            this.form.storeIdList = ''
          }
          this.$axios.fetchPost(api.purchase.pcPurchaseDefault, this.form).then(data => {
            if (data.code === 200) {
              this.reset()
              this.$notify({
                type: "success",
                title: '提交操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({type: 'success', message: '操作成功'});
            } else {
              this.$notify({
                type: "error",
                title: '提交操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({type: 'error', message: data.errorMsg});
            }
            loading.close()
          }).catch((err) => {
            loading.close()
            this.$message({message: '请求失败', type: 'error'});
          });
        } else {
          return false
        }
      })
    }
  }
};
</script>
<style scoped>
   >>>.column-title::before{
         content: "";
         display: inline-block;
         width: 8px;
         height: 8px;
         border-radius: 50%;
         margin-right: 5px;
         margin-bottom: 2px;
         background: rgb(95,88,230);
     }
   .foot{
     text-align: center;
   }
   >>> .el-select__tags .el-tag.el-tag--info{
     padding-right:18px;
     max-width: unset;
   }
   >>> .el-tag.el-tag--info .el-tag__close{
     right:1px;
   }
</style>



// WEBPACK FOOTER //
// src/page/purchase/Setting.vue